import { render, staticRenderFns } from "./CreateProduceButton.vue?vue&type=template&id=54c921e8&"
import script from "./CreateProduceButton.vue?vue&type=script&lang=js&"
export * from "./CreateProduceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports